import { Component } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { User } from '@app/core/models';
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';


@Component({
  selector: 'create-edit-expense',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="800" title="{{ (mode == 'CREATE') ? 'Nuevo' : 'Editar' }} {{ label }} {{ (mode == 'CREATE') ? '' : '(Id: ' + form.value.id + ')' }}" *ngIf="opened" (close)="onClose()" [(state)]="windowState">
  
    <!-- {{ form.value | json }} Es valido: {{ form.valid }} -->
    
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">        
          <div class="row">              
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Fecha:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-datepicker formControlName="date" [format]="'dd-MMM-yyyy'"></kendo-datepicker>
                  </kendo-textbox-container>
                  <div *ngIf="f.date.invalid && (f.date.dirty || f.date.touched)">                  
                    <div *ngIf="f.date.errors">
                      <kendo-formerror *ngIf="f.date.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Proveedor:"></kendo-label>
                  <kendo-textbox-container>                                        
                    <dynamic-autocomplete formControlName="supplier" [table]="'expenses_inventories'" [valueField]="'supplier'" [showAll]="true" controlTrim></dynamic-autocomplete>
                  </kendo-textbox-container> 
                  <div *ngIf="f.supplier.invalid && (f.supplier.dirty || f.supplier.touched)">                  
                    <div *ngIf="f.supplier.errors">
                      <kendo-formerror *ngIf="f.supplier.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Tipo de gasto:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_expense_type" [table]="'expenses_types'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Forma de pago:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_payment_type" [table]="'payments_types'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>                  
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Importe:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-numerictextbox formControlName="cost" [format]="'c2'" [min]="0" [autoCorrect]="true"></kendo-numerictextbox>
                  </kendo-textbox-container> 
                  <div *ngIf="f.cost.invalid && (f.cost.dirty || f.cost.touched)">                  
                    <div *ngIf="f.cost.errors">
                      <kendo-formerror *ngIf="f.cost.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Autoriza:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_person_authorize" [table]="'persons'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>                  
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Descripción:"></kendo-label>
                  <kendo-textbox-container>                                        
                    <kendo-textbox formControlName="description" [clearButton]="true"></kendo-textbox>
                  </kendo-textbox-container> 
                  <div *ngIf="f.description.invalid && (f.description.dirty || f.description.touched)">                  
                    <div *ngIf="f.description.errors">
                      <kendo-formerror *ngIf="f.description.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Observaciones:" [optional]="true"></kendo-label>
                  <kendo-textbox-container>
                    <textarea kendoTextArea formControlName="observations" rows="3" controlTrim></textarea>
                  </kendo-textbox-container>
              </div>
          </div>
      </div>
    </form>

    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary ml-1" (click)="onSave()" [disabled]='!form.valid'>Guardar</button>
    </div>
       
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }    
  `],
  providers: [ DatasourceService ]
})    
export class CreateEditExpenseComponent extends CreateEditWindowComponent {

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    super(authService, service, alertService);

  }
  
  //@Override
  public getObjectString(dataItem: any): string {

    return [
      `Id: '${dataItem.id}'`,      
      `Fecha: '${this.intl.formatDate(dataItem.date, "yyyy-MM-dd")}'`,
      `Proveedor: '${dataItem.supplier}'`,
      `Descripción: '${dataItem.description}'`,
    ].join('\n')

  };

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {

    const tzDate = ZonedDate.fromUTCDate((dataItem) ? new Date(dataItem.date) : new Date(), environment.timezone);

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),   
      'date': new FormControl((dataItem) ? new Date(tzDate.toUTCString().replace('Dev', 'Dec')): new Date(), Validators.required), 
      'supplier': new FormControl((dataItem) ? dataItem.supplier: "", Validators.required),
      'cost': new FormControl((dataItem) ? dataItem.cost: 0, Validators.required),
      'description': new FormControl((dataItem) ? dataItem.description: "", Validators.required),
      'id_person_authorize': new FormControl((dataItem) ? dataItem.id_person_authorize: 0, Validators.required),
      'id_expense_type': new FormControl((dataItem) ? dataItem.id_expense_type: 1, Validators.required),
      'id_payment_type': new FormControl((dataItem) ? dataItem.id_payment_type: 1, Validators.required),
      'observations': new FormControl((dataItem) ? dataItem.observations: ""),
    });

  };

  //@Override
  protected getData(formGroup: FormGroup): Object {
    
    return Object.assign({}, formGroup.value, { 
      date: this.intl.formatDate(formGroup.value.date, "yyyy-MM-dd"),
    });

  };

}
